import React from "react";

// styling
import "./assessments.css";

// react radio
import Radio from "@material-ui/core/Radio";

const AssessmentOption = (props) => {
  const isCheckd = props.answerType.toString() === props.answer ? true : false;
  return (
    // <Animated animationIn="zoomIn" animationOut="zoomOut" isVisible={true} animationInDuration={800} animationInDelay={650}>
    <li
      className="answer-option"
      style={isCheckd ? { backgroundColor: "#4d4d4d" } : {}}
    >
      <Radio
        checked={props.answerType.toString() === props.answer}
        id={props.answerType}
        value={props.answerType}
        // disabled={props.answer}
        onChange={props.onAnswerSelected}
        // onClick={selectionChanges}
        className="radio-button"
      />

      <label htmlFor={props.answerType}>{props.answerContent}</label>
    </li>
    // </Animated>
  );
};

export default AssessmentOption;



// WEBPACK FOOTER //
// ./src/common/assessmentOption.Component.tsx